import { Link } from 'react-router-dom'
import Instagram from '../../assets/icons/InstagramIcon'
import Linkedin from '../../assets/icons/Linkedin'
import LinkSection from './LinkSection'
import SafeltoLogo from '../../assets/icons/SafeltoLogo'
import NewsLetter from '../LandingPage/Faq/NewsLetter'


const Footer = () => {
  return (
    <footer className="bg-white dark:bg-black text-black dark:text-white mt-16 text-sm">
      {/* Newsletter Section */}
      <section className="py-10 px-5">
        <div className="container mx-auto">
          <NewsLetter />
        </div>
      </section>

      {/* Link Section */}
      <section className="py-8 px-5">
        <div className="container mx-auto flex flex-col lg:flex-row justify-between">
          <div className="max-w-xs">
            <Link to="/">
              <SafeltoLogo className="fill-black dark:fill-gray-300" />
            </Link>
            <p className="mt-2 text-gray-400 font-normal text-sm leading-relaxed">
              Your Seamless living with secured access.
            </p>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap md:gap-4 cursor-pointer md:items-center">
            <LinkSection title="Home" href="/" />
            <LinkSection title="About Us" href="/about" />
            <LinkSection title="Contact Us" href="/contact-us" />
            <LinkSection title="Privacy Policy" href="/privacy-policy" />
            {/* <LinkSection title="Blog" href="/blog" /> */}
            {/* <LinkSection title="Why Choose Us" href="/why-choose-us" /> */}
          </div>
        </div>
      </section>

      {/* Social Media Section */}
      <div className="container mx-auto border-t border-dashed border-gray-400 flex flex-wrap items-center justify-left md:justify-end gap-4 py-4 px-5">
        <a
          href="https://www.instagram.com/safeltoapp"
          target="_blank"
          rel="noopener noreferrer"
          className="md:mt-2"
        >
          <Instagram />
        </a>
        {/* 
        <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
          <Facebook />
        </a> */}

        <a
          href="https://www.linkedin.com/company/safelto/posts/?feedView=all"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Linkedin />
        </a>

        {/* <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
          <Twitter />
        </a> */}
      </div>
    </footer>
  )
}

export default Footer
